import { render, staticRenderFns } from "./Productsunderdevelopment.vue?vue&type=template&id=a57c7974"
import script from "./Productsunderdevelopment.vue?vue&type=script&lang=js"
export * from "./Productsunderdevelopment.vue?vue&type=script&lang=js"
import style0 from "./Productsunderdevelopment.vue?vue&type=style&index=0&id=a57c7974&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports